import { Vue, Component, Watch } from 'vue-property-decorator';
import { documentAddRmaObj } from './AddRma.services';
import { Addrmamodel } from './Addrma.model';


@Component
export default class AddRma extends Vue{
    public text : any;
    public values :any;
    public postData : any;
    public Order_number : any;
    public reason : any;
    public flag : any;
    public showsearch : any = true;
    public quantity : any;
    public ticketno : any;
    public comments :any;
    public file : any;
    public checkbox : any;
    public id : any;
    public errorMessage: string = '';
    public orderErrorMessage: string = '';
    public formData : any;
    public successMessage: string ='';
    public buttonDisabled: boolean = false;
    public images: any;
    public $loading:any;
    public fullPage: boolean = false;
    public data(){
        return{
            id:'',
            fullPage: false,
            formData:'',
            text : '',
            postData : '',
            Order_number : '',
            reason : '',
            values : '',
            flag : '',
            showsearch : true,
            quantity : '',
            ticketno : '',
            comments : '',
            file : '',
            checkbox  :'',
            orderErrorMessage:'',
            buttonDisabled: false,
            images:[]
        }
    }
    flagSet(){
        this.showsearch = true
        this.flag = false;
        this.text = '';
    }    
    rmaSearch(){
        let postData = {
            data:{
                order_number: this.text,
            }
        }
        this.$validator.validate().then(valid => {
            if (valid) {
                this.getDocumentRmaSearchFilter(postData);
                // this.buttonDisabled = false;
            }else{
                this.buttonDisabled = false;
            }
        });
    }

    public async getDocumentRmaSearchFilter(data:any){
        console.log(this.$refs.formContainer);
        let loader = this.$loading.show({
            // Optional parameters
            container: this.fullPage ? null : this.$refs.formContainer,
            canCancel: false,
            height:20,
            width:20
            // onCancel: this.onCancel,
          }); 
        const res = documentAddRmaObj.getDocumentAddRmaSearchFilter(data).then((res: any) =>{
            let success: number = res.data.success;
            console.log("success - ",success);
            if(success === 1){
            this.values = res.data.data.rma_list;
            this.reason = res.data.data.rma_list.reason;
            this.Order_number = res.data.data.order_id;
            this.flag = true;
            this.showsearch = false;
            this.orderErrorMessage = '';
            loader.hide();
        }else{
            this.orderErrorMessage = res.data.data.message;
            loader.hide();
        }
        }).catch((err: any) =>{
            console.log(err);
            loader.hide();
        });
    }
    addButtonSubmit(){
        let form = <any>document.getElementById("form-id") as HTMLFormElement;
        let formData = new FormData(form);
        // formData.append('document_file', this.file);
        let postData = {
                order_number  : this.Order_number,
                return_reason : this.reason,
                ticket_number : this.ticketno,
                comments : this.comments,
        }
        for ( var key in postData ) {
            formData.append(key, postData[key]);
        }
        let sku_list :any = [];
        
        
        for (let items in this.values){
            // console.log("items - ", items);
            let id = "id_"+this.values[items].id;
            let c_id = "check_"+this.values[items].id;
            let element = <HTMLInputElement> document.getElementById(c_id);
            let isChecked = element.checked;
            let el = (<HTMLInputElement>document.getElementById(id)).value;
            if(isChecked){
                let sku_list_single = {
                    sku: this.values[items].sku,
                    quantity:el
                };
                sku_list.push(sku_list_single);
          
            }    
        }    
        formData.append("product_detail", JSON.stringify(sku_list));
        // form file list app
        for (var i = 0; i < this.file.length; i++) {
            var file_id = this.file[i];
            // Add the file to the request.
           formData.append('image_list', file_id, file_id.name);
          }
        // -----------------------------------------------------------------------
        // formData.append("document_list",this.file);
        this.$validator.validate().then(valid => {
            console.log("Hello")
                if(this.file.length> 0){
                    let data: any = this.$validator.errors.items;
                    var index = data.findIndex(function(item, i){
                        console.log("item - ", item);
                        return item.field === 'document_list';
                      });
                      this.$validator.errors.items.splice(index,1);
                    console.log(index);
                     valid = true; 
                }

                if (valid) {
                    console.log("form valid");
                        this.getDocumentAddSkuList(formData);
                    
                }else{
                console.log(this.$validator.errors.items);
            };
        });
    }
    public async getDocumentAddSkuList(data:any){
        let loader = this.$loading.show({
            // Optional parameters
            container: this.fullPage ? null : this.$refs.formContainer,
            canCancel: false,
            height:55,
            width:55
            // onCancel: this.onCancel,
          });
         const response = documentAddRmaObj.getDocumentAddSkuList(data).then((res: any) =>{
            console.log(response);
            let variant = 'success';
            this.$bvToast.toast('New RMA added successfully !', {
                  title: 'Add RMA',
                  autoHideDelay: 1500,
                  variant: variant,
                  solid: true
            });
            loader.hide();
            this.$bvModal.hide('modal-1');
        }).catch((err: any) =>{
            console.log(err);
            loader.hide();
        });
    }
    handleFileUpload(){
        this.file = document.getElementById('document') as HTMLElement;
        this.file = this.file.files;
        console.log('file list -', this.file);
        this.successMessage = '';
        this.errorMessage = '';
        console.log("File File File")
        // console.log(this.file);
    }
    formatNames(files) {
        if (files.length === 1) {
          return files[0].name.substring(1,5);
        } else {
          return `${files.length} files selected`;
        }
    }
  
}
